<template>
    <div class="assign-page-footer tw-flex tw-items-center tw-justify-between tw-gap-4 tw-border tw-border-gray-200 tw-bg-white tw-px-5 tw-py-2 tw-shadow-lg">
        <div class="tw-flex tw-items-center tw-gap-3">
            <div class="tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-blue-200 tw-bg-blue-50 tw-text-blue-600">
                <a-icon type="user" />
            </div>
            <div>
                <div class="tw-text-sm tw-font-bold tw-text-gray-800">{{ selectedDriverName }}</div>
                <div class="tw-text-xs tw-font-bold tw-text-gray-400">
                    {{ selectedCount }} {{ $t("assignDriver.packagesSelected") }}
                </div>
            </div>
        </div>
        <div class="tw-flex tw-items-center tw-gap-3">
            <button
                class="tw-h-8 tw-px-3 tw-rounded tw-border tw-border-gray-200 tw-bg-white tw-text-xs tw-font-bold tw-text-gray-600 hover:tw-bg-gray-50"
                type="button"
                @click.prevent="$emit('cancel')"
            >
                {{ $t("cancel") }}
            </button>
            <button
                class="tw-h-8 tw-px-3 tw-rounded tw-border tw-border-gray-200 tw-bg-gray-50 tw-text-xs tw-font-bold tw-text-gray-600 hover:tw-bg-gray-100 disabled:tw-opacity-50"
                type="button"
                :disabled="!selectedCount"
                @click.prevent="$emit('clear')"
            >
                {{ $t("assignDriver.clearSelection") }}
            </button>
            <ts-button
                color="primary"
                :disabled="!canAssign"
                @click.prevent="$emit('save')"
            >
                <i class="fa fa-check-circle-o tw-mr-1"></i>
                {{ $t("assignDriver.confirmAssign") }} ({{ selectedCount }}) {{ $t("assignDriver.packages") }}
            </ts-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "AssignActionFooter",
    props: {
        selectedDriverName: {
            type: String,
            required: true
        },
        selectedCount: {
            type: Number,
            default: 0
        },
        canAssign: {
            type: Boolean,
            default: false
        }
    }
};
</script>
